import api from "../index";

// Create a announcement
export const createAnnouncement = async (values: any) => {
  return await api.post("/announcement", values);
};

// Get all announcements
export const getAllAnnouncements = async () => {
  return await api.get(`/announcements`);
};

// Get a announcement by id
export const getAnnouncementById = async (id: any) => {
  return await api.get(`/announcement/${id}`);
};

// Update a announcement by id
export const updateAnnouncementById = async (id: any, values: any) => {
  return await api.put(`/announcement/${id}`, values);
};

// Delete a announcement by id
export const deleteAnnouncementById = async (id: any) => {
  return await api.delete(`/announcement/${id}`);
};
